import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface ConfirmationPopupProps {
  isOpen: boolean;
  title?: string;
  description: string;
  handleClose: () => void;
  handleConfirm: () => void;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({ isOpen, title, description, handleClose, handleConfirm }) => {
  return (
    <React.Fragment>
    <Dialog
      open={isOpen}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Disagree</Button>
        <Button onClick={handleConfirm}>Agree</Button>
      </DialogActions>
    </Dialog>
    </React.Fragment>
  );
};

export default ConfirmationPopup;
